import type { Posting } from "@/lib/api/catalogue";
import type { PastedJob } from "./pastedJob";

/**
 * A posting as the tailor is asked for it, with the resume box's text. The
 * tailor goes by `posting`. The rest is what it falls back on if the
 * posting cannot be named, and envoy takes only an `https` address, though
 * a board can link a posting over `http`.
 */
export function postingTailorJob(posting: Posting, resume: string): PastedJob {
    return {
        title: posting.title,
        company: posting.company,
        address: posting.url.replace(/^http:/i, "https:"),
        description: posting.description,
        resume,
        posting: {
            vendor: posting.source.toLowerCase(),
            board: posting.board,
            posting_id: posting.external_id,
        },
    };
}
